import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';

import {
  getAdditionalServicePopupIsConnection,
  getAdditionalServicePopupIsError, getAdditionalServicePopupIsLoading,
  getAdditionalServicePopupIsNoMoney, getAdditionalServicePopupIsPromised,
  getAdditionalServicePopupIsSuccess,
} from 'pages/Internet/store/selectors/servicesSelectors';

import { Connection, Error, NoMoney, Promised, Succesed, Loading } from './containers';

export const ConnectionConnected = compose(connect((state) => ({
  shouldRender: getAdditionalServicePopupIsConnection(state),
})), withRenderFlag)(Connection);
export const SuccessConnected = compose(connect((state) => ({
  shouldRender: getAdditionalServicePopupIsSuccess(state),
})), withRenderFlag)(Succesed);
export const PromisedConnected = compose(connect((state) => ({
  shouldRender: getAdditionalServicePopupIsPromised(state),
})), withRenderFlag)(Promised);
export const NoMoneyConnected = compose(connect((state) => ({
  shouldRender: getAdditionalServicePopupIsNoMoney(state),
})), withRenderFlag)(NoMoney);
export const LoadingConnected = compose(connect((state) => ({
  shouldRender: getAdditionalServicePopupIsLoading(state),
})), withRenderFlag)(Loading);
export const ErrorConnected = compose(connect((state) => ({
  shouldRender: getAdditionalServicePopupIsError(state),
})), withRenderFlag)(Error);
